export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "OU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "OU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "UU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "UU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "UU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "UU",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		tier: "UU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "UU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "UU",
	},
	pichu: {
		tier: "LC",
	},
	pikachu: {
		tier: "NFE",
	},
	raichu: {
		tier: "UU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		tier: "UU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "UU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "UU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "NFE",
	},
	clefable: {
		tier: "UU",
	},
	vulpix: {
		tier: "LC",
	},
	ninetales: {
		tier: "UU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "UU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NFE",
	},
	crobat: {
		tier: "UU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		tier: "OU",
	},
	bellossom: {
		tier: "UU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "UU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "UU",
	},
	diglett: {
		tier: "LC",
	},
	dugtrio: {
		tier: "OU",
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		tier: "UU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "OU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "UU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		tier: "OU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		tier: "UU",
	},
	politoed: {
		tier: "UU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "NFE",
	},
	alakazam: {
		tier: "OU",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NFE",
	},
	machamp: {
		tier: "OU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		tier: "UU",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		tier: "UU",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	golem: {
		tier: "UU",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		tier: "UU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		tier: "OU",
	},
	slowking: {
		tier: "UU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "OU",
	},
	farfetchd: {
		tier: "UU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		tier: "UU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "UU",
	},
	grimer: {
		tier: "LC",
	},
	muk: {
		tier: "UU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "OU",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "NFE",
	},
	gengar: {
		tier: "OU",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		tier: "OU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		tier: "UU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "UU",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		tier: "UU",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		tier: "OU",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		tier: "OU",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		tier: "UU",
	},
	hitmonchan: {
		tier: "UU",
	},
	hitmontop: {
		tier: "OU",
	},
	lickitung: {
		tier: "UU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "UU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "OU",
	},
	chansey: {
		tier: "UU",
	},
	blissey: {
		tier: "OU",
	},
	tangela: {
		tier: "UU",
	},
	kangaskhan: {
		tier: "UU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		tier: "OU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "UU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		tier: "OU",
	},
	mrmime: {
		tier: "OU",
	},
	scyther: {
		tier: "UU",
	},
	scizor: {
		tier: "OU",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		tier: "OU",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "UU",
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		tier: "UU",
	},
	pinsir: {
		tier: "UU",
	},
	tauros: {
		tier: "OU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "OU",
	},
	lapras: {
		tier: "UU",
	},
	ditto: {
		tier: "UU",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		tier: "OU",
	},
	jolteon: {
		tier: "OU",
	},
	flareon: {
		tier: "UU",
	},
	espeon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	umbreon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	porygon: {
		tier: "UU",
	},
	porygon2: {
		tier: "OU",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		tier: "UU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "UU",
	},
	aerodactyl: {
		tier: "OU",
	},
	snorlax: {
		tier: "OU",
	},
	articuno: {
		tier: "UU",
	},
	zapdos: {
		tier: "OU",
	},
	moltres: {
		tier: "UU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		tier: "OU",
	},
	mewtwo: {
		tier: "Uber",
	},
	mew: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	chikorita: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	bayleef: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	meganium: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	cyndaquil: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	quilava: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	typhlosion: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	totodile: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	croconaw: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	feraligatr: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		tier: "UU",
	},
	hoothoot: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	noctowl: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		tier: "UU",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		tier: "UU",
	},
	chinchou: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	lanturn: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "UU",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		tier: "UU",
	},
	mareep: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	flaaffy: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	ampharos: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		tier: "UU",
	},
	sudowoodo: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		tier: "UU",
	},
	aipom: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	sunkern: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	sunflora: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	yanma: {
		tier: "UU",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		tier: "OU",
	},
	murkrow: {
		tier: "UU",
	},
	misdreavus: {
		tier: "UU",
	},
	unown: {
		tier: "UU",
	},
	wynaut: {
		tier: "Uber",
	},
	wobbuffet: {
		tier: "Uber",
	},
	girafarig: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	pineco: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	forretress: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	dunsparce: {
		tier: "UU",
	},
	gligar: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	snubbull: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	granbull: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	qwilfish: {
		tier: "UU",
	},
	shuckle: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	heracross: {
		tier: "OU",
	},
	sneasel: {
		tier: "UU",
	},
	teddiursa: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	ursaring: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		tier: "UU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "UU",
	},
	corsola: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		tier: "UU",
	},
	delibird: {
		tier: "UU",
	},
	mantine: {
		tier: "UU",
	},
	skarmory: {
		tier: "OU",
	},
	houndour: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	houndoom: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		tier: "OU",
	},
	stantler: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	smeargle: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	miltank: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	raikou: {
		tier: "UU",
	},
	entei: {
		tier: "UU",
	},
	suicune: {
		tier: "UU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		tier: "OU",
	},
	lugia: {
		tier: "Uber",
	},
	hooh: {
		tier: "Uber",
	},
	celebi: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	treecko: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	grovyle: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	sceptile: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	torchic: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	combusken: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	blaziken: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	mudkip: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	marshtomp: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	swampert: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	poochyena: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	mightyena: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	zigzagoon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	linoone: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	wurmple: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	silcoon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	beautifly: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	cascoon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	dustox: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	lotad: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	lombre: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	ludicolo: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	seedot: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	nuzleaf: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	shiftry: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	taillow: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	swellow: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	wingull: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	pelipper: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	ralts: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	kirlia: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	gardevoir: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	surskit: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	masquerain: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	shroomish: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	breloom: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	slakoth: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	vigoroth: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	slaking: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	nincada: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	ninjask: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	shedinja: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	whismur: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	loudred: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	exploud: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	makuhita: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	hariyama: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	nosepass: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	skitty: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	delcatty: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	sableye: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	mawile: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	aron: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	lairon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	aggron: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	meditite: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	medicham: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	electrike: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	manectric: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	plusle: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	minun: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	volbeat: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	illumise: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	roselia: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	gulpin: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	swalot: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	carvanha: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	sharpedo: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	wailmer: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	wailord: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	numel: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	camerupt: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	torkoal: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	spoink: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	grumpig: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	spinda: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	trapinch: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	vibrava: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	flygon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	cacnea: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	cacturne: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	swablu: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	altaria: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	zangoose: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	seviper: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	lunatone: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	solrock: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	barboach: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	whiscash: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	corphish: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	crawdaunt: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	baltoy: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	claydol: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	lileep: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	cradily: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	anorith: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	armaldo: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	feebas: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	milotic: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	castform: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	castformsunny: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	castformrainy: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	castformsnowy: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	kecleon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	shuppet: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	banette: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	duskull: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	dusclops: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	tropius: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	chimecho: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	absol: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	snorunt: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	glalie: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	spheal: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	sealeo: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	walrein: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	clamperl: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	huntail: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	gorebyss: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	relicanth: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	luvdisc: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	bagon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	shelgon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	salamence: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	beldum: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	metang: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	metagross: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	regirock: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	regice: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	registeel: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	latias: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	latios: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	kyogre: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	groudon: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	rayquaza: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	jirachi: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	deoxys: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
	deoxysattack: {
		tier: "Uber",
	},
	deoxysdefense: {
		tier: "Uber",
	},
	deoxysspeed: {
		tier: "Unreleased",
		isNonstandard: "Unobtainable",
	},
};
